export const nodeIconBackgrounds = [
  'black',
  'blue',
  'blueDark',
  'blueLight',
  'gray',
  'green',
  'orange',
  'red',
] as const;

export type NodeIconBackground = (typeof nodeIconBackgrounds)[number];

export const nodeIconOutlines = [
  'blueDark',
  'greenDark',
  'lime',
  'orangeDark',
  'redDark',
] as const;

export type NodeIconOutline = (typeof nodeIconOutlines)[number];

export interface NodeStyle {
  background?: NodeIconBackground;
  outline?: NodeIconOutline;
}
